<!--
    描述：材料列表页面
    时间：2020-6-16
    Created by zjj

	编辑时间： 2021-03-12
	编辑内容： 修复页面新增 资源价格时的 下拉选bug
	编辑人： 王帅
-->
<template>
	<div class="Material-library">
		<div class="w-page-main">
			<div class="w-page-header">
				<div class="form-left">
					<el-form label-width="80px"
							 size="small"
							 :model="searchForm">
						<el-row>
							<el-col :span="8">
								<el-form-item label="资源类型">
									<el-select v-model="searchForm.sourceType"
											   placeholder="请选择资源类型">
										<el-option v-for="item in zylxList"
												   :key="item.value"
												   :label="item.sname"
												   :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="地区">
									<el-cascader v-model="searchplaceMap"
												 @change="getAreaSearch"
												 clearable
												 @visible-change="handleData"
												 ref="cascader"
												 :options="options"
												 placeholder="请选择省市"></el-cascader>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="价格类型">
									<el-select v-model="searchForm.priceType"
											   placeholder="请选择价格类型">
										<el-option v-for="item in priceList"
												   :key="item.value"
												   :label="item.label"
												   :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>

				<SearchArea ref="searchContent"
							v-model="searchForm.sname"
							placeholderName="材料名称"
							:showMore="false"
							@on-search="onSearch"
							@on-refresh="onRefresh"
							@on-reset="onReset"
							@on-input="onInput">
				</SearchArea>
				<div class="btnGroups ml10">
					<el-button type="primary"
							   size="small"
							   @click="addMaterial">添加资源价格</el-button>
				</div>
			</div>
			<div class="w-page-container">
				<MaterialTable ref="materialTable"
							   @on-editChange="editChange"
							   :searchForm="searchForm"></MaterialTable>
			</div>
		</div>
		<!-- 弹窗 -->
		<el-dialog :title="dialogModel.title"
				   :visible.sync="dialogModel.visible"
				   :width="dialogModel.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<div class="text-center h100 overflow-hidden">
				<el-form ref="addForm"
						 class="pdr5"
						 :model="addForm"
						 :rules="addRules"
						 label-width="120px">

					<el-form-item label="资源类型"
								  prop="sourceType">
						<el-select v-model="addForm.sourceType"
								   @change="changeSelect"
								   clearable
								   placeholder="请选择资源类型">
							<el-option v-for="item in zylxList"
									   :key="item.value"
									   :label="item.sname"
									   :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="价格类型"
								  class="text-left">
						<el-radio v-model="addForm.priceType"
								  label="1">信息价</el-radio>
						<el-radio v-model="addForm.priceType"
								  label="2">市场价</el-radio>
					</el-form-item>
					<el-form-item label="资源名称"
								  prop="resourceId">
						<el-select v-model="addForm.resourceId"
								   filterable
								   clearable
								   @change="changeSelectName"
								   placeholder="请选择">
							<el-option v-for="item in ResourceList"
									   :key="item.id"
									   :label="item.sname"
									   :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="系统编码"
								  prop="sysCode">
						<el-input v-model="addForm.sysCode"
								  disabled></el-input>
					</el-form-item>
					<el-form-item label="规格型号"
								  v-if="currentSelectIndex !=='1046002'"
								  prop="specification">
						<el-input v-model="addForm.specification"
								  disabled></el-input>
					</el-form-item>
					<el-form-item label="单位"
								  v-if="currentSelectIndex !=='1046002'"
								  prop="unit">
						<el-select v-model="addForm.unit"
								   disabled>
							<el-option v-for="item in cldwList"
									   :key="item.value"
									   :label="item.sname"
									   :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="税率"
								  v-if="currentSelectIndex !=='1046002'"
								  prop="taxRate">
						<el-input v-model="addForm.taxRate"
								  disabled></el-input>
					</el-form-item>
					<el-form-item label="含税价格"
								  v-if="currentSelectIndex !=='1046002'"
								  prop="withTax">
						<el-input type="number"
								  @input="handleInput($event,1)"
								  v-model.number="addForm.withTax">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
					<el-form-item label="除税价格"
								  prop="excise">
						<el-input type="number"
								  @input="handleInput($event,2)"
								  v-model.number="addForm.excise">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
					<el-form-item label="所属月份"
								  prop="yearAndMonth">
						<el-date-picker v-model="addForm.yearAndMonth"
										type="month"
										value-format="yyyy-MM"
										placeholder="所属月份">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="地区"
								  prop="province">
						<el-cascader v-model="placeMap"
									 @change="getArea"
									 @visible-change="handleData"
									 clearable
									 ref="cascader"
									 :options="options"
									 placeholder="请选择省市区县"></el-cascader>
					</el-form-item>
					<el-form-item label="价格信息来源"
								  prop="priceResource">
						<el-select v-model="addForm.priceResource"
								   placeholder="请选择">
							<el-option v-for="item in xxjglyList"
									   :key="item.value"
									   :label="item.label"
									   :value="item.sname">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>

			<!-- 底部按钮 -->
			<div slot="footer"
				 v-if="dialogModel.type === 'add'"
				 class="dialog-footer text-center">
				<el-button @click="handleClose"
						   size="small">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import MaterialTable from './material_table'
import SearchArea from 'components/searchArea/searchArea'
import { mapState } from 'vuex'
import { provinceAndCityData } from 'element-china-area-data'
import {
	selectResourceByCondition,
	insertOrUpdateResource
} from '@/api/modules/resource_subscription'
export default {
	name: 'Data_classification',
	components: { SearchArea, MaterialTable },
	data() {
		return {
			options: provinceAndCityData,
			//搜索表单
			searchForm: {
				current: 1,
				size: 10,
				province: '',
				city: '', //	string	必须地区
				sourceType: '', //资源类型
				sname: '',
				priceType: '' //价格类型
			},
			searchplaceMap: [],
			placeMap: [],
			// 弹窗对象
			addForm: {
				id: '',
				sname: '', //	string	必须资源名称
				resourceId: '', //	string	必须资源码表值
				sourceType: '', //	string	必须资源类型
				priceType: '1', //	number	必须价格类型
				yearAndMonth: '', //	string	必须年月
				withTax: 0, //	number	必须含税价
				excise: 0, //	number	必须除税价
				taxRate: 0, //	number	必须税率
				sysCode: '', //	string	必须编码
				unit: '', //	string	必须单位
				specification: '', //	string	必须规格型号
				province: '',
				city: '', //	string	必须地区
				priceResource: '' //	string	必须码表
			},
			priceList: [
				{
					value: '1',
					label: '信息价'
				},
				{
					value: '2',
					label: '市场价'
				}
			],
			// 弹窗对象
			dialogModel: {
				title: '添加资源价格',
				visible: false,
				width: '650px',
				type: 'add'
			},
			ResourceList: [],
			btnLoading: false,
			// 表单验证规则
			addRules: {
				// 地区
				province: [
					{
						type: 'string',
						required: true,
						message: '请选择地区',
						trigger: 'blur'
					}
				],
				//月份
				yearAndMonth: [
					{
						type: 'string',
						required: true,
						message: '请选择时间',
						trigger: 'change'
					}
				],
				//资源类型
				sourceType: [
					{
						type: 'string',
						required: true,
						message: '请选择资源类型',
						trigger: 'change'
					}
				],
				//资源名称
				resourceId: [
					{
						type: 'string',
						required: true,
						message: '请选择资源名称',
						trigger: 'change'
					}
				],
				//信息来源
				priceResource: [
					{
						type: 'string',
						required: true,
						message: '请选择信息来源',
						trigger: 'change'
					}
				]
			},
			currentSelectIndex: ''
		}
	},
	created() {},
	methods: {
		//数字输入事件
		handleInput(value, number) {
			if (number === 1) {
				if (value != '') {
					if (value.indexOf('.') > -1) {
						this.addForm.withTax = value.slice(
							0,
							value.indexOf('.') + 3
						)
					} else {
						this.addForm.withTax = value
					}
				}
			} else {
				if (value != '') {
					if (value.indexOf('.') > -1) {
						this.addForm.excise = value.slice(
							0,
							value.indexOf('.') + 3
						)
					} else {
						this.addForm.excise = value
					}
				}
			}
		},

		// 资源类型 切换事件
		changeSelect(val) {
			this.addForm.sname = ''
			this.currentSelectIndex = val
			this.getselectCondition()
		},

		//资源名称切换事件
		changeSelectName(val) {
			let _item = this.ResourceList.find(x => x.id === val)
			if (_item) {
				this.addForm.sname = _item.sname
				this.addForm.sysCode = _item.code
				this.addForm.unit = _item.unit
				this.addForm.specification = _item.specification
				this.addForm.taxRate = _item.taxRate
			} else {
				this.addForm.sname = ''
				this.addForm.sysCode = ''
				this.addForm.unit = ''
				this.addForm.specification = ''
				this.addForm.taxRate = ''
			}
		},

		//资源名称
		getselectCondition() {
			selectResourceByCondition({
				type: this.currentSelectIndex,
				name: ''
			}).then(res => {
				if (res.code === 0) {
					this.ResourceList = res.data
					if (this.addForm.sname && this.currentSelectIndex != '') {
						this.addForm.sysCode = res.data[0].code
						this.addForm.unit = res.data[0].unit + ''
						this.addForm.specification = res.data[0].specification
						this.addForm.taxRate = res.data[0].taxRate
					}
				}
			})
		},

		//下拉框出现/隐藏时触发事件
		handleData(data) {
			this.options = this.options.map(item => {
				if (item.label != '安徽省') {
					return { ...item, disabled: true }
				} else {
					return { ...item, disabled: false }
				}
			})
		},

		//省市区
		getArea(data) {
			if (data != null && data.length > 0) {
				this.addForm.province = data[0]
				this.addForm.city = data[1]
			}
		},

		//搜索省市
		getAreaSearch(data) {
			if (data != null && data.length > 0) {
				this.searchForm.province = data[0]
				this.searchForm.city = data[1]
			}
		},

		// 关闭弹窗事件
		handleClose() {
			this.ResourceList = ''
			this.addForm.id = ''
			this.currentSelectIndex = ''
			this.dialogModel.visible = false
			this.addForm.sname = ''
			this.addForm.sourceType = ''
			this.addForm.priceType = '1'
			this.addForm.yearAndMonth = ''
			this.addForm.withTax = 0
			this.addForm.excise = 0
			this.addForm.taxRate = 0
			this.addForm.sysCode = ''
			this.addForm.unit = ''
			this.addForm.specification = ''
			this.addForm.province = ''
			this.addForm.city = ''
			this.placeMap = []
			this.addForm.priceResource = ''
			this.dialogModel.type = 'add'
			this.dialogModel.width = '650px'
		},

		//点击确定
		doConfirm() {
			this.$refs.addForm.validate(valid => {
				if (valid) {
					this.addForm.unit === 'undefined'
						? (this.addForm.unit = '')
						: this.addForm.unit
					insertOrUpdateResource(this.addForm).then(res => {
						if (res.code === 0) {
							this.dialogModel.visible = false
							this.$refs.materialTable.getTableData()
							this.addForm = res.data
						}
					})
				}
			})
		},

		//编辑回调事件
		editChange(item) {
			this.currentSelectIndex = item.sourceType
			this.dialogModel.visible = true
			this.addForm.id = item.id
			this.dialogModel.title = '编辑资源价格'
			this.addForm.resourceId = item.resourceId
			this.addForm.sname = item.sname
			this.addForm.sourceType = item.sourceType
			this.addForm.priceType = item.priceType + ''
			this.addForm.yearAndMonth = item.yearAndMonth
			this.addForm.withTax = item.withTax
			this.addForm.excise = item.excise
			this.addForm.taxRate = item.taxRate
			this.addForm.sysCode = item.sysCode
			this.addForm.unit = item.unit
			this.addForm.specification = item.specification
			this.addForm.priceResource = item.priceResource
			this.addForm.province = item.province
			this.addForm.city = item.city

			this.changeSelect(item.sourceType)

			this.placeMap = [
				item.province != null ? item.province + '' : '',
				item.city != null ? item.city + '' : ''
			]
		},

		//新增材料
		addMaterial() {
			this.dialogModel.visible = true
			this.dialogModel.type = 'add'
		},

		// 筛选框输入事件
		onInput(val, attr) {
			this.searchForm[attr] = val
		},

		// 筛选框确认查询事件
		onSearch() {
			this.$refs.materialTable.getTableData()
		},

		// 查询组件 刷新按钮
		onRefresh() {
			// 先重置
			this.onReset()
			this.$refs.materialTable.getTableData()
		},

		// 筛选框重置事件
		onReset() {
			this.searchplaceMap = []
			for (let k in this.searchForm) {
				this.searchForm[k] = ''
			}
		}
	},
	computed: {
		// 资源类型
		...mapState('dict', {
			zylxList: state => state.zylx,
			xxjglyList: state => state.xxjgly,
			cldwList: state => state.cldw
		})
	},
	watch: {}
}
</script>

<style scoped lang="less">
</style>

